// src/pages/stockTransfer/transferItemUtils.js

export const getTransferItemDisplayName = (item) => {
  if (!item.Product) return '';

  if (item.variationId && item.ProductVariation) {
    const attributes = item.ProductVariation.attributeValues
      ?.map((av) => `${av.ProductAttribute?.name}: ${av.value}`)
      .filter(Boolean) || [];
    return attributes.length ? `${item.Product.name} (${attributes.join(', ')})` : item.Product.name;
  }

  return item.Product.name;
};

export const getTransferItemSku = (item) => {
  if (item.variationId && item.ProductVariation) return item.ProductVariation.sku;
  return item.Product?.sku;
};

export const getTransferItemImage = (item) => {
  if (item.variationId && item.ProductVariation) {
    return item.ProductVariation.images?.[0]?.path || item.Product?.images?.[0]?.path;
  }
  return item.Product?.images?.[0]?.path;
};
